import '../scss/vendor.scss'
import '../scss/app.scss'

import 'focus-visible'

import store from 'store2'
import React from 'react'
import { createRoot } from 'react-dom/client'
import queryString from 'query-string'
import Components from './components'
import { BrowserRouter as Router } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import { Howl } from 'howler'

const queryToken = queryString.parse(window.location.search).token as string

if (queryToken) {
  store.set('token', queryToken)
}

window.isIframe = window.self !== window.top

//

const wrapper = document.createElement('div')

wrapper.classList.add('layout')

if (window.isIframe) {
  wrapper.classList.add('is-iframe')
}

const container = document.body.appendChild(wrapper)
const root = createRoot(container)

//

const ring = new Howl({
  src: ['/sounds/empty.mp3'],
})

const handler = () => {
  document.removeEventListener('click', handler, false)
  ring.play()
}

document.addEventListener('click', handler, false)

//

const dsn = process.env.DSN

if (dsn) {
  Sentry.init({
    dsn: dsn,
    // to chyba trzeba jakoś spiąć z connected-react-router
    // integrations: [
    //   new Integrations.BrowserTracing({
    //     routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    //   }),
    // ],
    integrations: [new BrowserTracing()],
    ignoreErrors: ['ResizeObserver loop limit exceeded'],
  })
}

root.render(
  <Router>
    <Components />
  </Router>
)
